import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface GetOrderIdByClaimGroupQueryArgs {
  claimGroupId: string;
}

export const getOrderIdByClaimGroupRequest = ({
  claimGroupId,
}: GetOrderIdByClaimGroupQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/orderId`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getOrderIdByClaimGroupQuery = async (
  args: GetOrderIdByClaimGroupQueryArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      getOrderIdByClaimGroupRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
